import type { PolicyRecord, Record, RuleOptionGroup } from "./getDemoData.types"
import type { EnforcementStatus } from "./useAiPolicies.types"

export const isGroupEnforced = (group: PolicyRecord) =>
  group.actions.enabled && group.actions.enforceRuleOnRuntime

export const getEnforcementStatus = (
  record: Record
): EnforcementStatus | undefined => {
  if (record.type === "heading") return undefined

  const groups = [...record.allowed, ...record.notAllowed]

  if (groups.length === 0) return "monitor"

  return groups.every(isGroupEnforced) ? "enforced" : "monitor"
}

export const getRuleOption = (groups: RuleOptionGroup[], id: string) =>
  groups.flatMap((group) => group.options).find((option) => option.id === id)
